import Authentication from "./libs/api/services/Authentication";
import ClinicianManagementLayout from "./screens/layout/ClinicianManagementLayout";
import PatientManagementLayout from "./screens/layout/PatientManagementLayout";
import { AdminLayout } from "./screens/layout/adminLayout";
import { ConfigLayout } from "./screens/layout/configLayout";
import { MenuContainer } from "./screens/menu/MenuContainer";
import FacilityManagementSearchBar from "./screens/search/FacilityManagementSearchBar";
import FilteredSearchBar from "./screens/search/FilteredSearchBar";
import UserSearchBar from "./screens/search/UserSearchBar";
import SysAdmin from "./screens/section/SysAdmin";
import UISectionLayout from "./screens/section/UISectionLayout";
import DataAccessManagement from "./screens/section/access/facility/DataAccessManagement";
import AlertsOverview from "./screens/section/alerts/AlertsOverview";
import CalendarFacilityAdmin from "./screens/section/calendar/facility/CalendarFacilityAdmin";
import CalendarSyncConfiguration from "./screens/section/calendar/sync/CalendarSyncConfiguration";
import CalendarCanvas from "./screens/section/calendar/v2/calendarCanvas";
import Dashboard from "./screens/section/dashboards/Dashboard";
import FacilitiesAdmin from "./screens/section/facility/admin/FacilitiesAdmin";
import FacilityManagementScreen from "./screens/section/facility/management/FacilityManagementScreen";
import LogsSectionLayout from "./screens/section/logs/LogsSectionLayout";
import ServiceProviderAdmin from "./screens/section/messaging/ServiceProviderAdmin";
import MessagingAudienceAdmin from "./screens/section/messaging/admin/MessagingAudienceAdmin";
import MessagingTemplateAdmin from "./screens/section/messaging/admin/MessagingTemplateAdmin";
import SystemMessagingAccounts from "./screens/section/messaging/admin/SystemMessagingAccounts";
import UserEmailAccountConfiguration from "./screens/section/messaging/admin/facility/UserEmailAccountConfiguration";
import FacilityMessagingConfigurationWizard from "./screens/section/messaging/configuration/facility/screens/FacilityMessagingConfigurationWizard";
import MessageManagement from "./screens/section/messaging/management/MessageManagement";
import PatientProfileAdmin from "./screens/section/patient/admin/PatientProfileAdmin";
import PatientDMS from "./screens/section/patient/dms/PatientDMS";
import WorkFlowPatientHistory from "./screens/section/patient/history/WorkFlowPatientHistory";
import PatientManagementScreen from "./screens/section/patient/management/PatientManagementScreen";
import PatientProfileDashboard from "./screens/section/patient/management/PatientProfileDashboard";
import PatientProfileManagement from "./screens/section/patient/management/PatientProfileManagement";
import QuestionnairesAdmin from "./screens/section/questionnaires/QuestionnairesAdmin";
import FormBuilder from "./screens/section/questionnaires/builder/FormBuilder";
import QuestionnaireBuilder from "./screens/section/questionnaires/builder/QuestionnaireBuilder";
import QCapture from "./screens/section/questionnaires/capture/QCapture";
import PatientFormComponent from "./screens/section/questionnaires/patient/PatientFormComponent";
import PatientForms from "./screens/section/questionnaires/patient/PatientForms";
import PatientQuestionnaireResults from "./screens/section/questionnaires/patient/PatientQuestionnaireResults";
import PatientQuestionnaires from "./screens/section/questionnaires/patient/PatientQuestionnaires";
import PatientQuestionnairesDashboard from "./screens/section/questionnaires/patient/PatientQuestionnairesDashboard";
import SharedAccessScreen from "./screens/section/share/SharedAccessScreen";
import FacilityTeams from "./screens/section/teams/FacilityTeams";
import ManageTerms from "./screens/section/tncs/ManageTerms";
import ManageFacilityTnCs from "./screens/section/tncs/facility/ManageFacilityTnCs";
import ToDoListScreen from "./screens/section/todo/ToDoListScreen";
import ToDoListAdmin from "./screens/section/todo/facility/ToDoListAdmin";
import RegisterUser from "./screens/section/user/RegisterUser";
import UserFacilities from "./screens/section/user/UserFacilities";
import UserPersmissions from "./screens/section/user/UserPermissions";
import UserRequests from "./screens/section/user/UserRequests";
import UserAdminEdit from "./screens/section/user/admin_edit_user/UserAdminEdit";
import UserManagementScreen from "./screens/section/user/new_user_management/UserManagementScreen";
import WorkflowBreakdown from "./screens/section/workflow/configuration/facility/wizard/WorkflowBreakdown";
import WorkflowWizard from "./screens/section/workflow/configuration/facility/wizard/WorkflowWizard";

export const UserMenuAccess = {
	'Dashboard': {
		"My Profile": { users: ['Patient', 'Client'], descr: 'View / Update Your Profile' },
		"Questionnaires": { users: ['Patient', 'Client', 'Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'], descr: 'Fill out questionnnaires' },
		"Patients": { users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance',], descr: 'Manage Patients' },
		"Calendar": { users: ['Patient', 'Client', 'Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'], descr: 'Manage Calendar' },
		"Messages": { users: ['Patient', 'Client', 'Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'], descr: 'View / Send Messages' },
		"To Do": { users: ['Patient', 'Client', 'Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'], descr: 'Complete To Do List Tasks' },
		"Dashboard": { users: ['Patient', 'Client', 'Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'], descr: 'View Dashboard' },
	},
	"ClinicianPatient": {
		"Profile": { users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'], descr: 'Manage a patients profile' },
		"Patients": { users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'], descr: 'Manage Patients' },
		"History": { users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'], descr: 'View patients history' },
		"Messages": { users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'], descr: 'View messages relating to a patient' },
		"Questionnaires": { users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'], descr: 'View patients questionnaire results' },
		"Calendar": { users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'], descr: 'View patients calendar' },
		"Back": { users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'], descr: 'Navigate back to dashboard' },
	},
	"UserConfiguration": {
		"Email": { users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'], descr: 'Setup your email account' },
		"User Requests": { users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'], descr: 'Accept / Decline user requests' },
		"Facility Configurations": { users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'], descr: 'Configure the facility' },
		"Dashboard": { users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'], descr: 'View Dashboard' },
		"Patient": { users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Super', 'System Admin'], descr: 'Manage facility patient profile details' },
		"Users": { users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Super', 'System Admin'], descr: 'Manage facility users' },
		"Questionnaires / Forms": { users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Super', 'System Admin'], descr: 'Manage facilities Questionnaires / Forms' },
		"Messaging": { users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Super', 'System Admin'], descr: 'Manage Messaging service for the facilty' },
	},
	// "Receptionist": { // Moved to clinician
	// "Dashboard": { users: ['Admin', 'Office Admin'] },
	// "Messages": { users: ['Admin', 'Office Admin'] },
	// "Calendar": { users: ['Admin', 'Office Admin'] },
	// "To Do": { users: ['Admin', 'Office Admin'] },
	// }
	// "Receptionist"
	// "Admin"
	// "Patient-Admin"
	// "UserManagement"
	// "Messaging"
	// "Questionaire"
	// "ReceptionistPatient"
}

export const DashboardMapping = {
	"Clinician": {
		main: "CLINICIAN_DASHBOARD",
		calendar: "CLINICIAN"
	},
	"Clinical User": {
		main: "CLINICIAN_DASHBOARD",
		calendar: "CLINICIAN"
	},
	"Patient": {
		main: "PATIENT_DASHBOARD",
		calendar: "PATIENT"
	},
	"Client": {
		main: "PATIENT_DASHBOARD",
		calendar: "PATIENT"
	},
	"Admin": {
		main: "ADMIN_DASHBOARD",
		calendar: "ADMIN"
	},
	"Office Admin": {
		main: "ADMIN_DASHBOARD",
		calendar: "ADMIN"
	},
}

const PatientManageMent = [
	{
		route: '/Dashboard/Patient',
		component: <ClinicianManagementLayout
			search={<FilteredSearchBar section={'Patient Management'} />}
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="ClinicianPatient" activeSection="Profile" />}
			container={<PatientProfileManagement />}
			breadcrums={[{ name: 'Home', location: '/Dashboard' }
				, { name: 'New Patient', location: '/Dashboard/Patient', active: true }]} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Add new patient',
	}, {
		route: '/Dashboard/Patients',
		component: <ClinicianManagementLayout
			search={<FilteredSearchBar section={'Patient Management'} />}
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Dashboard" activeSection="Patients" />}
			container={<PatientManagementScreen />}
			breadcrums={[{ name: 'Home', location: '/Dashboard' }
				, { name: 'Patients', location: '/Dashboard/Patients', active: true }]} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Add new patient',
	},
	{
		route: '/Dashboard/Patient/:id',
		component: <ClinicianManagementLayout
			search={<FilteredSearchBar section={'Patient Management'} />}
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="ClinicianPatient" activeSection="Profile" />}
			container={<PatientProfileManagement />}
			breadcrums={[
				{ name: 'Home', location: '/Dashboard' },
				{ name: 'Patient', location: '/Dashboard/Patient/[PatientID]' },
				{ name: '[PatientName]', location: '/Dashboard/Patient/[PatientID]/Dashboard' },
				{ name: 'Profile', location: '/Dashboard/Patient', active: true }
			]} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage patients profile',
	},
	{
		route: '/Dashboard/Patient/:id/Dashboard',
		component: <ClinicianManagementLayout
			search={<FilteredSearchBar section={'Patient Management'} />}
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="ClinicianPatient" activeSection="Profile" />}
			container={<PatientProfileDashboard
				type="CLINICIAN_PATIENT_DASHBOARD" />}
			breadcrums={[
				{ name: 'Home', location: '/Dashboard' },
				{ name: 'Patient', location: '/Dashboard/Patient/[PatientID]' },
				{ name: '[PatientName]', location: '/Dashboard/Patient/[PatientID]/Dashboard' },
				{ name: 'Profile', location: '/Dashboard/Patient', active: true }
			]} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'View Patient Management Dashboard',
	},
	{
		route: '/Dashboard/Patient/:id/History',
		component: <ClinicianManagementLayout
			search={<FilteredSearchBar section={'Patient History'} />}
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="ClinicianPatient" activeSection="History" />}
			container={<WorkFlowPatientHistory />}
			breadcrums={[
				{ name: 'Home', location: '/Dashboard' },
				{ name: 'Patient', location: '/Dashboard/Patient/[PatientID]' },
				{ name: '[PatientName]', location: '/Dashboard/Patient/[PatientID]/Dashboard' },
				{ name: 'History', location: '/Dashboard/Patient', active: true }
			]} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'View patient history',
	},
	{
		route: '/Dashboard/Patient/:id/:event/Files',
		component: <ClinicianManagementLayout menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="ClinicianPatient" activeSection="History" />}
			container={<PatientDMS />}
			breadcrums={[
				{ name: 'Home', location: '/Dashboard' },
				{ name: 'Patient', location: '/Dashboard/Patient/[PatientID]' },
				{ name: '[PatientName]', location: '/Dashboard/Patient/[PatientID]/Dashboard' },
				{ name: 'History', location: '/Dashboard/Patient/[PatientID]/History', active: false },
				{ name: 'Event', location: '/Dashboard/Patient', active: true }
			]} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'View / Import patient documents',
	},
]

const MessageManagementItems = [
	// {
	// route: '/Dashboard/Messages',
	// component: <ClinicianManagementLayout menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Dashboard" activeSection="Messages" />} container={<MessageManagement />} search={<PatientearchBar />}
	// breadcrums={[{ name: 'Home', location: '/Dashboard' }, { name: 'Messages', location: '/PAtient/Messages', active: true }]} />,
	// users: ['Patient', 'Client'],
	// authenticate: true,
	// descr: 'View / Send Messages (Internal Messages only)',
	// },
	{
		route: '/Dashboard/Messages',
		component: <ClinicianManagementLayout
			search={<FilteredSearchBar section={'Messages'} />}
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Dashboard" activeSection="Messages" />}
			container={<MessageManagement />}
			breadcrums={[
				{ name: 'Home', location: '/Dashboard' },
				{ name: 'Messages', location: '/Dashboard/Messages', active: true }
			]} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client'],
		authenticate: true,
		descr: 'View / Send Messages',
	},
	{
		route: '/Dashboard/Messages/Patient/:id',
		component: <ClinicianManagementLayout
			search={<FilteredSearchBar section={'Patient Messages'} />}
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="ClinicianPatient" activeSection="Messages" />}
			container={<MessageManagement />}
			breadcrums={[
				{ name: 'Home', location: '/Dashboard' },
				{ name: 'Patient', location: '/Dashboard/Patient/[PatientID]' },
				{ name: '[PatientName]', location: '/Dashboard/Patient/[PatientID]/Dashboard' },
				{ name: 'Messages', location: '/Dashboard/Patient', active: true }
			]} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'View Messages relating to patient',
	},
	// Messaging Service Providers
	{
		route: '/Facility/Configuration/Messaging',
		component: <PatientManagementLayout nofilter
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="UserConfiguration" activeSection="Facility Configurations" />}
			container={<FacilityMessagingConfigurationWizard />} />,
		users: ['Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Setup messaging service providers',
	},
	{
		route: '/Facility/Configuration/Templates',
		component: <ConfigLayout
			search={<FacilityManagementSearchBar />} nofilter
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()}
				menu="UserConfiguration" activeSection="Messaging" />}
			breadcrums={[
				{ name: 'Facility Administration', location: '/Facility/Configuration' },
				{ name: 'Facility', location: '/Facility/Configuration', active: false },
				{ name: 'Message Templates', location: '/Facility/Configuration/Templates', active: true },
			]}
			container={<MessagingTemplateAdmin startStep={1} />} />,
		users: ['Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Setup facility message templates',
	},
	// {
	// route: '/Facility/Messages',
	// component: <ConfigLayout menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Dashboard" activeSection="Messages" />}
	// container={<MessageManagement />}
	// breadcrums={[
	// { name: 'Home', location: '/Clinician' },
	// { name: 'Messages', location: '/Clinician/Messages', active: true }
	// ]} />,
	// users: ['Super', 'Facility Manager','Technical Support',],
	// authenticate: true,
	// descr: 'Setup facility message templates',
	// },
]

const UserConfigurationManagementItems = [
	// {
	// route: '/Dashboard/Configuration',
	// component: <AdminLayout
	// menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="UserConfiguration" activeSection="" />}
	// breadcrums={[
	// { name: 'Facility Administration', location: "/" + "Dashboard" + '/Configuration' },
	// ]}
	// container={<UserConfiguration />} />,
	// users: ['Clinician','Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
	// authenticate: true,
	// descr: 'Setup own calendars / email account',
	// },
	{
		route: '/Dashboard/Configuration/Email',
		component: <AdminLayout menu={<MenuContainer key={"menu_cnt" + new Date().getTime()}
			menu="UserConfiguration" activeSection="Email" />}
			search={<FacilityManagementSearchBar section={`Email configuration for ${JSON.parse(Authentication.UserName() && Authentication.UserName())}`} />}
			breadcrums={[
				{ name: 'Facility Administration', location: "/" + "Dashboard" + '/Configuration' },
				{ name: 'Email Account', location: '/Facility/Configuration', active: true },
			]}
			container={<UserEmailAccountConfiguration user={{ id: Authentication.UserId(true) }} />} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Configure own email accounts',
	}, {
		route: '/Dashboard/Configuration/Email/:state',
		component: <AdminLayout menu={<MenuContainer key={"menu_cnt" + new Date().getTime()}
			menu="UserConfiguration" activeSection="Email" />}
			breadcrums={[
				{ name: 'Facility Administration', location: "/" + "Dashboard" + '/Configuration' },
				{ name: 'Email Account', location: '/Facility/Configuration', active: true },
			]}
			container={<UserEmailAccountConfiguration user={{ id: Authentication.UserId(true) }} />} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Verify own email account with OAuth',
	},
]

const UserManagementItems = [
	{
		route: '/Dashboard/Configuration/UserRequests',
		component: <AdminLayout
			search={
				undefined
				// <UserSearchBar facility={"Dashboard"} />
			}
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()}
				menu="UserConfiguration" activeSection="User Requests" />} container={<UserRequests />}
			breadcrums={[
				{ name: 'Facility Administration', location: '/Facility/Configuration' },
				{ name: 'Users', location: '/Facility/Configuration/users', active: false },
				{ name: 'User Requests', location: "Dashboard" + '/Configuration', active: true }
			]} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Approve / Decline User requests',
	},
	{
		route: '/Dashboard/Configuration',
		component: <ConfigLayout
			// search={<FacilityManagementSearchBar section={`${Authentication.getFacilityName()} Configuration`} />}
			// search={<FacilityManagementSearchBar section={`${JSON.parse(Authentication.UserName())} Settings`} />}
			search={<FacilityManagementSearchBar section={`Settings`} />}
			breadcrums={[
				{ name: 'Settings', location: "/" + "Dashboard" + '/Configuration' },]}
			nofilter menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="UserConfiguration" activeSection="Settings" />} container={<FacilityManagementScreen />} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: false,
		descr: 'Manage facility configuration',
	},
	// TODO: Compare with Facility/Configuration/users for redundancies
	// {
	// route: '/Dashboard/Configuration/Users',
	// component: <AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()}
	// menu="UserConfiguration" activeSection="Users" />}
	// search={<UserSearchBar facility={"Dashboard"} />}
	// breadcrums={[
	// { name: 'Facility Administration', location: "/" + "Dashboard" + '/Configuration' },
	// { name: 'Users', location: "Dashboard" + '/Configuration', active: true }]}
	// container={<FacilityUserManagement />} />,
	// users: ['Clinician','Temporary Access', 'Clinical User'],
	// authenticate: true,
	// descr: 'Manage users for a facility',
	// },
	{
		route: '/Facility/Configuration/Users',
		component: <AdminLayout key={"AL_" + new Date().getTime()}
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="UserConfiguration" activeSection="Users" />}
			search={<FilteredSearchBar hideSearch={true} />}
			breadcrums={[
				{ name: 'Facility Administration', location: '/Facility/Configuration' },
				{ name: Authentication.getFacilityName(), location: '/Facility/Configuration' },
				{ name: 'Users', location: 'Facility/Configuration', active: true }]}
			container={<UserManagementScreen />} />,
		users: ['Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage users for a facility',
	},
	{
		route: '/Facility/Configuration/Users/Add',
		component: <ConfigLayout key={"AL_" + new Date().getTime()}
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()}
				menu="UserConfiguration" activeSection="Users" />}
			search={<FacilityManagementSearchBar />}
			breadcrums={[
				{ name: 'Facility Administration', location: '/Facility/Configuration' },
				{ name: 'Users', location: '/Facility/Configuration/Users', active: false },
				{ name: 'Add', location: '/Facility/Configuration', active: true }
			]}

			container={<RegisterUser facility={Authentication.getFacility()} />} />,
		users: ['Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Add users to the facility',
	},
	{
		route: '/Facility/Configuration/users/:id',
		component: <ConfigLayout key={"AL_" + new Date().getTime()}
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="UserConfiguration" activeSection="Users" />}
			// search={<UserSearchBar facility={Authentication.getFacility()} />}
			search={<FacilityManagementSearchBar section={'         '} />}
			container={<UserAdminEdit />}
			breadcrums={[
				{ name: 'Facility Administration', location: '/Facility/Configuration' },
				{ name: 'Users', location: '/Facility/Configuration/Users', active: false },
				{ name: '[UserName]', location: '/Facility/Configuration/users/[UserID]' }, { name: 'Manage', location: '/Facility/Configuration/users/add', active: true }]}
		/>,
		users: ['Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage a user in the facility',
	},
]

const QuestionnaireManagementItems = [
	{
		route: '/Dashboard/Questionnaires',
		component: <ClinicianManagementLayout container={<PatientQuestionnairesDashboard />} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Dashboard" activeSection="Questionnaires" />}
			// search={<PatientearchBar />}
			breadcrums={[{ name: 'Home', location: '/Dashboard' }, { name: 'Questionnaires', location: '/Patient/Questionnaires', active: true }]} />,
		users: ['Patient', 'Client'],
		// authenticate: true,
		descr: 'View assigned questionnaires',
	},
	{
		route: '/Dashboard/Questionnaire/:questionnaireId/:QuestionnaireAssignmentId',
		component: <ClinicianManagementLayout container={<QCapture />} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Dashboard" activeSection="Questionnaires" />}
			// search={<PatientearchBar />}
			breadcrums={[{ name: 'Home', location: '/Dashboard' }, { name: 'Questionnaires', location: '/Patient/Questionnaires', active: true }]} />,
		users: ['Patient', 'Client'],
		// authenticate: true,
		descr: 'Complete a questionnaire',
	},
	{
		route: '/Dashboard/Patient/:id/Questionnaires',
		component: <ClinicianManagementLayout
			search={<FilteredSearchBar section={'Questionnaires'} />}
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="ClinicianPatient" activeSection="Questionnaires" />}
			container={<PatientQuestionnaires />}
			breadcrums={[
				{ name: 'Home', location: '/Dashboard' },
				{ name: 'Patient', location: '/Dashboard/Patient/[PatientID]' },
				{ name: '[PatientName]', location: '/Dashboard/Patient/[PatientID]/Dashboard' },
				{ name: 'Questionnaires', location: '/Dashboard/Patient', active: true }
			]} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		// authenticate: true,
		descr: 'Assign a questionnare',
	},
	// Same as next used as redirect
	{
		route: '/Clinician/Patient/:id/Questionanire/:questionair/:QuestionnaireAssignmentId',
		component: <ClinicianManagementLayout menu={<MenuContainer key={"menu_cnt" + new Date().getTime()}
			menu="ClinicianPatient" activeSection="Questionnaires" />}
			container={
				// V1 + V2
				<PatientQuestionnaireResults />
			}
			// search={<PatientearchBar />}
			breadcrums={[
				{ name: 'Home', location: '/Dashboard' },
				{ name: 'Patient', location: '/Dashboard/Patient/[PatientID]' },
				{ name: '[PatientName]', location: '/Dashboard/Patient/[PatientID]/Dashboard' },
				{ name: 'Questionnaires', location: '/Dashboard/Patient/[PatientID]/Questionnaires' },
				{ name: 'Questionnaire', location: '/Dashboard/Patient', active: true }
			]} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		// authenticate: true,
		descr: 'View questionnaire results',
	},
	{
		route: '/Dashboard/Patient/:id/Questionanire/:questionair/:QuestionnaireAssignmentId',
		component: <ClinicianManagementLayout menu={<MenuContainer key={"menu_cnt" + new Date().getTime()}
			menu="ClinicianPatient" activeSection="Questionnaires" />}
			container={
				// V1 + V2
				<PatientQuestionnaireResults />
			}
			// search={<PatientearchBar />}
			breadcrums={[
				{ name: 'Home', location: '/Dashboard' },
				{ name: 'Patient', location: '/Dashboard/Patient/[PatientID]' },
				{ name: '[PatientName]', location: '/Dashboard/Patient/[PatientID]/Dashboard' },
				{ name: 'Questionnaires', location: '/Dashboard/Patient/[PatientID]/Questionnaires' },
				{ name: 'Questionnaire', location: '/Dashboard/Patient', active: true }
			]} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		// authenticate: true,
		descr: 'View questionnaire results',
	},
	{
		route: '/Dashboard/Patient/:id/Forms',
		component: <ClinicianManagementLayout
			search={<FilteredSearchBar section={'Forms'} />}
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="ClinicianPatient" activeSection="Questionnaires" />}
			container={<PatientForms />}
			breadcrums={[
				{ name: 'Home', location: '/Dashboard' },
				{ name: 'Patient', location: '/Dashboard/Patient/[PatientID]' },
				{ name: '[PatientName]', location: '/Dashboard/Patient/[PatientID]/Dashboard' },
				{ name: 'Forms', location: '/Dashboard/Patient', active: true }
			]} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		// authenticate: true,
		descr: 'Start a form',
	},
	{
		route: '/Dashboard/Patient/:id/Form/:questionair/:QuestionnaireAssignmentId',
		component: <ClinicianManagementLayout menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="ClinicianPatient" activeSection="Questionnaires" />}
			container={<PatientFormComponent />}
			// search={<PatientearchBar />}
			breadcrums={[
				{ name: 'Home', location: '/Dashboard' },
				{ name: 'Patient', location: '/Dashboard/Patient/[PatientID]' },
				{ name: '[PatientName]', location: '/Dashboard/Patient/[PatientID]/Dashboard' },
				{ name: 'Forms', location: '/Dashboard/Patient/[PatientID]/Forms' },
				{ name: 'Form', location: '/Dashboard/Patient', active: true }
			]} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		// authenticate: true,
		descr: 'Complete a form',
	},
	{
		route: '/Facility/Configuration/questionnaires',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()}
				menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="UserConfiguration" activeSection="Questionnaires / Forms" />}
				container={<QuestionnairesAdmin />}
				breadcrums={[
					{ name: 'Facility Administration', location: "/Facility/Configuration" },
					{ name: 'Questionnaires', location: '/Facility/questionnaires', active: true }
				]} />,
		users: ['Super', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'System Admin'],
		// authenticate: true,
		descr: 'Manage facility questionnaires / forms',
	},
	{
		route: '/Facility/questionnaires/builder',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()}
				menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="UserConfiguration" activeSection="Questionnaires / Forms" />}
				container={<QuestionnaireBuilder />}
				breadcrums={[
					{ name: 'Facility Administration', location: "/Facility/Configuration" },
					{ name: 'Questionnaires', location: '/Facility/Configuration/questionnaires', active: false },
					{ name: 'Questionnaire Builder', location: '/Facility/Configuration/questionnaires', active: true }
				]} />,
		users: ['Super', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'System Admin'],
		authenticate: true,
		descr: 'Manage facility questionnaires',
	},
	{
		route: '/Facility/form/builder',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()}
				menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="UserConfiguration" activeSection="Questionnaires / Forms" />}
				container={<FormBuilder />}
				breadcrums={[
					{ name: 'Facility Administration', location: "/Facility/Configuration" },
					{ name: 'Forms', location: '/Facility/Configuration/questionnaires', active: false },
					{ name: 'Form Builder', location: '/Facility/Configuration/questionnaires', active: true }
				]} />,
		users: ['Super', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'System Admin'],
		authenticate: true,
		descr: 'Manage facility forms',
	},
]

const FacilityManagementItems = [
	// {
	// route: '/Dashboard',
	// component: <PatientManagementLayout nofilter menu={
	// <MenuContainer key={"menu_cnt" + new Date().getTime()} menu="UserConfiguration" activeSection="Facility Configurations" />}
	// container={<FacilityManagementScreen />} />,
	// users: ['Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
	// authenticate: true,
	// descr: 'View facility management dashboard',
	// },
	{
		route: '/Facility/Configuration',
		component: <ConfigLayout
			search={<FacilityManagementSearchBar />}
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()}
				menu="UserConfiguration" activeSection="Facility Configurations"
			/>}
			breadcrums={[
				{ name: 'Facility Administration', location: "/" + "Dashboard" + '/Configuration' },
				{ name: 'Facility', location: '/Facility/Configuration/Users', active: true },
			]}
			container={<FacilityManagementScreen />} />,
		users: ['Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Configure a facility',
	},
	// TODO: Check for breadcrums elsewhere
	{
		route: '/Facility/Configuration/Events',
		component: <PatientManagementLayout nofilter
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="UserConfiguration" activeSection="Facility Configurations" />}
			container={<WorkflowWizard />} />,
		users: ['Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Setup facility work flows',
	},
	{
		route: '/Facility/Configuration/Event/Breakdown',
		component: <PatientManagementLayout nofilter
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="UserConfiguration" activeSection="Facility Configurations" />}
			container={<WorkflowBreakdown />} />,
		users: ['Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Setup facility work flows',
	},
	{
		route: '/sys-admin/patient/event/Breakdown',
		component: <PatientManagementLayout nofilter
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="UserConfiguration" activeSection="Facility Configurations" />}
			container={<WorkflowBreakdown />} />,
		users: ['Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Setup facility work flows',
	},
	{
		route: '/Facility/Configuration/TNC',
		component: <AdminLayout key={"AL_" + new Date().getTime()}
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()}
				menu="UserConfiguration" activeSection="Users" />}
			search={<FacilityManagementSearchBar section={`Managing terms and conditions for ${Authentication.getFacilityName()}`} />}
			breadcrums={[
				{ name: 'Facility Administration', location: "/" + "Dashboard" + '/Configuration' },
				{ name: Authentication.getFacilityName(), location: '/Facility/Configuration' },
				{ name: 'Terms and conditions', location: 'Facility/Configuration', active: true }]}
			container={<ManageFacilityTnCs facility={Authentication.getFacility()} />} />,
		users: ['Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage facilities terms and conditions',
	},
	// Sys admin facilities

	{
		route: '/sys-admin/facilities',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()}
				menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Admin" activeSection="Facilities" />}
				breadcrums={[{ name: 'System Administration', location: '/sys-admin' }]} container={<FacilitiesAdmin />} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage facilities on the system',
	},
]

const AlertManagementItems = [
	{
		route: '/Dashboard/Alerts',
		component: <ClinicianManagementLayout menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Dashboard" activeSection="Alerts" />}
			container={<AlertsOverview />}
			search={undefined} breadcrums={[{ name: 'Home', location: '/Dashboard' },
			{ name: 'Alerts', active: true }]}
		/>,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'View Alerts',
	},
]

const CalendarManagementItems = [
	// {
	// route: '/Dashboard/Calendar',
	// component: <ClinicianManagementLayout menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Dashboard" activeSection="Calendar" />} container={<CalendarSection filter={'Patient'} calendarType={'PATIENT'} />} search={undefined}
	// breadcrums={[{ name: 'Home', location: '/Dashboard' }, { name: 'Calendar', active: true }]} />,
	// users: ['Patient', 'Client'],
	// authenticate: true,
	// descr: 'View Own Calendar',
	// },
	// TODO : double check all calendar dashbaords
	{
		route: '/Dashboard/Calendar',
		component: <ClinicianManagementLayout
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Dashboard" activeSection="Calendar" />}
			container={
				// V1
				// <CalendarSection calendarType={Object.keys(DashboardMapping).includes("Dashboard") && DashboardMapping["Dashboard"].calendar} />
				// V2
				<CalendarCanvas calendarType={Object.keys(DashboardMapping).includes("Dashboard")} />
			}
			search={<FilteredSearchBar hideIcon section={'  '} />}
			breadcrums={[{ name: 'Home', location: '/Dashboard' }, { name: 'Calendar', active: true }]} />,
		users: ['Patient', 'Client', 'Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: false,
		descr: 'View / Manage calendar',
	},
	{
		route: '/Dashboard/Patient/:id/Calendar',
		component: <ClinicianManagementLayout menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="ClinicianPatient" activeSection="Calendar" />}
			// Use the new v2 calendar canvas for patient calendar pages
			container={<CalendarCanvas calendarType={Object.keys(DashboardMapping).includes("Dashboard") && `${DashboardMapping["Dashboard"].calendar}_PATIENT`} />}
			search={<FilteredSearchBar hideSearch section={'Calendar'} />}
			breadcrums={[
				{ name: 'Home', location: '/Dashboard' },
				{ name: 'Patient', location: '/Dashboard/Patient/[PatientID]' },
				{ name: '[PatientName]', location: '/Dashboard/Patient/[PatientID]/Dashboard' },
				{ name: 'Calendar', location: '/Dashboard/Patient', active: true }
			]} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'View patients calendar',
	},
	{
		route: '/Dashboard/configuration/Calendar',
		component: <AdminLayout menu={<MenuContainer key={"menu_cnt" + new Date().getTime()}
			menu="UserConfiguration" activeSection="Calendar" />}
			search={<FacilityManagementSearchBar section={`Calendar configuration for ${Authentication.UserName() && JSON.parse(Authentication.UserName())}`} />}
			breadcrums={[
				{ name: 'Facility Administration', location: "/" + "Dashboard" + '/Configuration' },
				{ name: 'Calendars', location: '/Facility/Configuration', active: true },
			]}
			container={<CalendarSyncConfiguration />} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Setup calendar events for a facility',
	},
	{
		route: '/Dashboard/configuration/Calendar/:id',
		component: <AdminLayout menu={<MenuContainer key={"menu_cnt" + new Date().getTime()}
			menu="UserConfiguration" activeSection="Calendar" />}
			breadcrums={[{ name: 'Facility Administration', location: "/" + "Dashboard" + '/Configuration' },
			{ name: 'Calendars', location: '/Facility/Configuration', active: true },
			]}
			container={<CalendarSyncConfiguration />} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Setup a synched calendar',
	},
	{
		route: '/Facility/Configuration/Calendar',
		component: <ConfigLayout
			search={<FacilityManagementSearchBar />} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="UserConfiguration" activeSection="Facility Configurations" />}
			container={<CalendarFacilityAdmin />}
			breadcrums={[
				{ name: 'Facility Administration', location: '/Facility/Configuration' },
				{ name: 'Facility', location: '/Facility/Configuration', active: false },
				{ name: 'Calendar', location: '/Facility/Configuration/Calendar', active: true },
			]}
		/>,
		users: ['Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Setup calendar events for a facility',
	},
	{
		route: '/Facility/Configuration/Access',
		component: <ConfigLayout
			search={<FacilityManagementSearchBar />} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="UserConfiguration" activeSection="Facility Configurations" />}
			container={<DataAccessManagement />}
			breadcrums={[
				{ name: 'Facility Administration', location: '/Facility/Configuration' },
				{ name: 'Facility', location: '/Facility/Configuration', active: false },
				{ name: 'Access', location: '/Facility/Configuration/Access', active: true },
			]}
		/>,
		users: ['Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Setup calendar events for a facility',
	},

	{
		route: '/Facility/Configuration/Teams',
		component: <ConfigLayout
			search={<FacilityManagementSearchBar />} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="UserConfiguration" activeSection="Facility Configurations" />}
			container={<FacilityTeams />}
			breadcrums={[
				{ name: 'Facility Administration', location: '/Facility/Configuration' },
				{ name: 'Facility', location: '/Facility/Configuration', active: false },
				{ name: 'Teams', location: '/Facility/Configuration/Teams', active: true },
			]}
		/>,
		users: ['Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage facilities teams',
	},
]

const ToDoManagementItems = [
	{
		route: '/Dashboard/ToDo',
		component: <ClinicianManagementLayout menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Dashboard" activeSection="To Do" />}
			breadcrums={[{ name: 'Home', location: "/" + "Dashboard" }, { name: 'To Do List', location: '/ToDo', active: true },]} container={<ToDoListScreen />} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: false,
		descr: 'Complete a to do list',
	},
	{
		route: '/Dashboard/ToDo',
		component: <ClinicianManagementLayout menu={<MenuContainer key={"menu_cnt" + new Date().getTime()}
			menu="Dashboard" activeSection="To Do" />}
			search={<FilteredSearchBar section={'To Do'} />}
			breadcrums={[
				{ name: 'Home', location: '/Dashboard' },
				{ name: 'To Do List', location: '/Dashboard/ToDo', active: true },
			]}
			container={<ToDoListScreen />} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: false,
		descr: 'Start / Complete a to do list',
	},
	{
		route: '/Facility/Configuration/todo',
		component: <ConfigLayout
			search={<FacilityManagementSearchBar />} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="UserConfiguration" activeSection="Facility Configurations" />}
			container={<ToDoListAdmin />}
			breadcrums={[
				{ name: 'Facility Administration', location: '/Facility/Configuration' },
				{ name: 'Facility', location: '/Facility/Configuration', active: false },
				{ name: 'To Do List', location: '/Facility/Configuration/todo', active: true },
			]}
		/>,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: false,
		descr: 'Setup to do events for a facility',
	},
]

const SystemAdminManagementItems = [
	{
		route: '/sys-admin',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()}
				menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Admin" activeSection="" />}
				breadcrums={[{ name: 'System Administration', location: '/sys-admin' }]} container={<SysAdmin />} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'View system admin dashboard',
	},
	{
		route: '/sys-admin/tncs',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()}
				menu="Admin" activeSection="" />}
				breadcrums={[{ name: 'System Administration', location: '/sys-admin' }]} container={<ManageTerms />} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage systems terms and conditions',
	},
	{
		route: '/sys-admin/users',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()}
				// container={<SysAdminUserDashboard />}
				container={<UserManagementScreen />}
				menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Admin" activeSection="Users" />}
				search={<FilteredSearchBar hideSearch={true} />}
				breadcrums={[
					{ name: 'System Administration', location: '/sys-admin' },
					{ name: 'Users', location: '/sys-admin/users', active: true }
				]} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'View systems users',
	},
	{
		route: '/sys-admin/users/add',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Admin" activeSection="Users" />}
				container={<RegisterUser />}
				search={<UserSearchBar />}
				breadcrums={[
					{ name: 'System Administration', location: '/sys-admin' },
					{ name: 'Users', location: '/sys-admin/users' },
					{ name: 'Add New User', location: '/sys-admin/users/add', active: true }
				]} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Create system users',
	},
	{
		route: '/sys-admin/user/manage/:id',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="UserManagement" activeSection="Users" />}
				search={<UserSearchBar />}
				container={<UserAdminEdit />}
				breadcrums={[
					{ name: 'System Administration', location: '/sys-admin' },
					{ name: 'Users', location: '/sys-admin/users' },
					{ name: '[UserName]', location: '/sys-admin/user/manage/[UserID]' },
					{ name: 'Manage', location: '/sys-admin/users/add', active: true }
				]} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage systems users',
	},
	{
		route: '/sys-admin/user/manage/:id/permissions',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="UserManagement" activeSection="Permissions" />}
				container={<UserPersmissions />}
				search={<UserSearchBar />}
				breadcrums={[
					{ name: 'System Administration', location: '/sys-admin' },
					{ name: 'Users', location: '/sys-admin/users' },
					{ name: '[UserName]', location: '/sys-admin/user/manage/[UserID]' },
					{ name: 'Permissions', location: '/sys-admin/users/[UserID]/permissions', active: true }
				]} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage systems user permissions',
	},
	{
		route: '/sys-admin/user/manage/:id/facilities',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="UserManagement" activeSection="Facilities" />}
				container={<UserFacilities />}
				search={<UserSearchBar />}
				breadcrums={[
					{ name: 'System Administration', location: '/sys-admin' },
					{ name: 'Users', location: '/sys-admin/users' },
					{ name: '[UserName]', location: '/sys-admin/user/manage/[UserID]' },
					{ name: 'Facilities', location: '/sys-admin/users/[UserID]/facilities', active: true }
				]} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage systems user facility roles',
	},
	{
		route: '/sys-admin/ux/:id',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Admin" activeSection="UI/UX Customise" />}
				// container={<UICustomisationScreen />}
				container={<UISectionLayout />}
				breadcrums={[
					{ name: 'System Administration', location: '/sys-admin' },
					{ name: 'UI/UX Customise', location: '/sys-admin/ux/0', active: true }
				]} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage systems UI',
	},
	{
		route: '/sys-admin/logs',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Admin" activeSection="Logs" />}
				container={<LogsSectionLayout />}
				breadcrums={[
					{ name: 'System Administration', location: '/sys-admin' },
					{ name: 'Logs', location: '/sys-admin/logs', active: true }
				]} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'View system logs',
	},
	{
		route: '/sys-admin/event/new',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Admin" activeSection="Logs" />}
				container={<WorkflowWizard />}
				breadcrums={[
					{ name: 'System Administration', location: '/sys-admin' },
					{ name: 'Create New Event', location: '/sys-admin/Event', active: true }
				]} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Create new system work flow',
	},
	{
		route: '/sys-admin/questionnaires',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Questionaire" activeSection="" />}
				container={<QuestionnairesAdmin />}
				breadcrums={[
					{ name: 'System Administration', location: '/sys-admin' },
					{ name: 'Questionnaires', location: '/sys-admin/questionnaires', active: true }
				]} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage system questionnaires / forms',
	},
	{
		route: '/sys-admin/questionnaires/builder',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Questionaire" activeSection="Questionnaire Builder" />}
				container={<QuestionnaireBuilder />}
				breadcrums={[
					{ name: 'System Administration', location: '/sys-admin' },
					{ name: 'Questionnaires', location: '/sys-admin/questionnaires', active: false },
					{ name: 'Questionnaire Builder', location: '/sys-admin/questionnaires', active: true }
				]} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage system questionnaires',
	},
	{
		route: '/sys-admin/form/builder',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Questionaire" activeSection="Form Builder" />}
				container={<FormBuilder />}
				breadcrums={[
					{ name: 'System Administration', location: '/sys-admin' },
					{ name: 'Questionnaires', location: '/sys-admin/questionnaires', active: false },
					{ name: 'Form Builder', location: '/sys-admin/questionnaires', active: true }
				]} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage system forms',
	},
	{
		route: '/sys-admin/patient',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Patient-Admin" activeSection="Patient Profile" />}
				container={<PatientProfileAdmin />}
				breadcrums={[
					{ name: 'System Administration', location: '/sys-admin' },
					{ name: 'Patient', location: '/sys-admin/patient', },
					{ name: 'Profile Configuration', location: '/sys-admin/patient/profile', active: true }
				]} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage system user setups',
	},
	{
		route: '/sys-admin/patient/profile',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Patient-Admin" activeSection="Patient Profile" />}
				container={<PatientProfileAdmin />}
				breadcrums={[
					{ name: 'System Administration', location: '/sys-admin' },
					{ name: 'Patient', location: '/sys-admin/patient', },
					{ name: 'Profile Configuration', location: '/sys-admin/patient/profile', active: true }
				]} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage system patient profile fields',
	},
	{
		route: '/sys-admin/patient/events',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Patient-Admin" activeSection="Patient Events" />}
				container={<WorkflowWizard />}
				breadcrums={[
					{ name: 'System Administration', location: '/sys-admin' },
					{ name: 'Patient', location: '/sys-admin/patient', },
					{ name: 'Event Configuration', location: '/sys-admin/patient/events', active: true }
				]} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage system patient profile work flow events',
	},
	{
		route: '/sys-admin/messaging',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Messaging" activeSection="Messaging Template" />}
				container={<MessagingTemplateAdmin startStep={1} />}
				breadcrums={[
					{ name: 'System Administration', location: '/sys-admin' },
					{ name: 'Messaging', location: '/sys-admin/messaging' },
					{ name: 'Messaging Templates', location: '/sys-admin/messaging/temlate', active: true }
				]} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage system messaging template',
	},
	{
		route: '/sys-admin/messaging/providers',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Messaging" activeSection="Messaging Template" />}
				container={<ServiceProviderAdmin startStep={1} />}
				breadcrums={[
					{ name: 'System Administration', location: '/sys-admin' },
					{ name: 'Messaging', location: '/sys-admin/messaging' },
					{ name: 'Messaging Templates', location: '/sys-admin/messaging/temlate', active: true }
				]} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage system messaging service providers',
	},
	{
		route: '/sys-admin/messaging/config',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Messaging" activeSection="System Messaging Accounts Setup" />}
				container={<SystemMessagingAccounts startStep={1} />}
				breadcrums={[
					{ name: 'System Administration', location: '/sys-admin' },
					{ name: 'Messaging', location: '/sys-admin/messaging' },
					{ name: 'Messaging Templates', location: '/sys-admin/messaging/temlate', active: true }
				]} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage system messaging accounts',
	},
	{
		route: '/sys-admin/messaging/template',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Messaging" activeSection="Messaging Template" />}
				container={<MessagingTemplateAdmin />}
				breadcrums={[
					{ name: 'System Administration', location: '/sys-admin' },
					{ name: 'Messaging', location: '/sys-admin/messaging' },
					{ name: 'Messaging Templates', location: '/sys-admin/messaging/temlate', active: true }
				]} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage system messaging templates',
	},
	// 
	{
		route: '/sys-admin/messaging/audience',
		component:
			<AdminLayout key={"AL_" + new Date().getTime()} menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Messaging" activeSection="Audience Groups" />}
				container={<MessagingAudienceAdmin />}
				breadcrums={[
					{ name: 'System Administration', location: '/sys-admin' },
					{ name: 'Messaging', location: '/sys-admin/messaging' },
					{ name: 'Audience Group', location: '/sys-admin/messaging/temlate', active: true }
				]} />,
		users: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		authenticate: true,
		descr: 'Manage system messaging audience',
	},
]



export const UserComponents = [
	// Dashboards
	// {
	// route: '/Dashboard',
	// component: <ClinicianManagementLayout menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Dashboard" activeSection="" />} search={<PatientearchBar />} container={<Dashboard type={Object.keys(DashboardMapping).includes("Dashboard") && DashboardMapping["Dashboard"].main} />}
	// breadcrums={[{ name: 'Home', location: '/Dashboard' }]} />,
	// users: ['Patient', 'Client'],
	// descr: 'View Dashboard (Patient Locked)',
	// authenticate: true
	// },
	{
		route: '/share/:ShareID',
		component: <SharedAccessScreen />,
		authenticate: false
	},
	{
		route: '/Dashboard',
		component: <ClinicianManagementLayout
			menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Dashboard" activeSection="Dashboard" />}
			// search={<PatientearchBar />}
			full
			breadcrums={[{ name: 'Home', location: "Dashboard" }]}
			container={
				<Dashboard type={'HOME'} />
				// <Dashboard test={"Dashboard"} type={"Dashboard" && DashboardMapping["Dashboard"].main} />
			} />,
		users: ['Clinician', 'Temporary Access', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
		descr: 'View Dashboard',
		authenticate: false
	},
	...PatientManageMent,
	...UserManagementItems,
	// Questionnaires
	...QuestionnaireManagementItems,
	// Messages
	...MessageManagementItems,
	// Profiles

	{
		route: '/Dashboard/Profile',
		component: <ClinicianManagementLayout menu={<MenuContainer key={"menu_cnt" + new Date().getTime()} menu="Dashboard" activeSection="My Profile" />} container={<PatientProfileManagement ownProfile patientUserID={Authentication.PID()} />}
			breadcrums={[{ name: 'Home', location: '/Dashboard' }, { name: 'Patient', location: '/PAtient/Patient/[PatientID]' }, { name: 'Profile', location: '/PAtient/Patient', active: true }]} />,
		users: ['Patient', 'Client'],
		descr: 'Manage own profile',
		authenticate: false
	},
	// Calendars
	...CalendarManagementItems,
	//To Do List
	...ToDoManagementItems,

	// Alerts
	...AlertManagementItems,
	// Configurations
	...UserConfigurationManagementItems,
	...FacilityManagementItems,
	...SystemAdminManagementItems
]
